// extracted by mini-css-extract-plugin
export var heroHeaderLeft = "t_qV d_gs d_cp";
export var heroHeaderCenter = "t_gt d_gt d_cp d_ds";
export var heroHeaderRight = "t_gv d_gv d_cp d_dt";
export var heroParagraphLeft = "t_qW d_gp d_cs";
export var heroParagraphCenter = "t_gq d_gq d_cs d_ds";
export var heroParagraphRight = "t_gr d_gr d_cs d_dt";
export var heroSliderBtnWrapperLeft = "t_rc d_dZ d_dY d_s d_bw d_bC d_bF";
export var heroSliderBtnWrapperCenter = "t_rd d_d0 d_dY d_s d_bw d_bz d_bF";
export var heroSliderBtnWrapperRight = "t_rf d_d1 d_dY d_s d_bw d_bD d_bF";
export var btnWrapper = "t_dZ";
export var wrapper = "t_p7 d_bw d_bL d_s d_D";
export var background = "t_pf d_9 d_X d_5 d_4 d_1 d_6";
export var frameWrapper = "t_rg d_s d_D d_W d_1 d_4 d_bg d_bb d_br";
export var videoFrame = "t_rh d_X";
export var videoOverlay = "t_rj d_s d_D d_X d_1";
export var arrow = "t_kK d_X d_k";
export var arrowLeft = "t_rk t_kK d_X d_k";
export var arrowRight = "t_rl t_kK d_X d_k";
export var buttonsWrapper = "t_rm d_bw d_bL";
export var dotsWrapper = "t_rn d_bw d_bL d_bz d_X";
export var dot = "t_rp d_bt d_dx";
export var dotActive = "t_rq t_rp d_bt d_dx";
export var heroSliderBackgroundImage = "t_gx d_s d_D d_bN d_bg";
export var loadingWrapper = "t_rr d_9 d_X d_5 d_4 d_1 d_6";
export var topAlt = "t_gz d_gz d_gy d_bw d_bL d_s";
export var top = "t_gB d_gB d_gy d_bw d_bL d_s";
export var bottomAlt = "t_gD d_gD d_9 d_X d_5 d_4 d_1 d_6 d_gy d_bw d_bL";
export var bottom = "t_gF d_gF d_9 d_X d_5 d_4 d_1 d_6 d_gy d_bw d_bL";
export var heroExceptionSmall = "t_q2 x_q2";
export var heroExceptionNormal = "t_q3 x_q3";
export var heroExceptionLarge = "t_q4 x_q4";